import styled from '@emotion/styled';

export const Wrapper = styled.div`
  display: grid;
  justify-items: center;
  justify-content: center;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 1.875rem;
  margin: 0 auto;
  padding: 3.125rem 0 6.25rem;
`;
